import PropTypes from 'prop-types';
import { forwardRef } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';

// constant
const headerSX = {
  '& .MuiCardHeader-action': { mr: 0 },
  '& .MuiCardHeader-content': { fontFamily: 'Mark-Medium !important' },
  '& .MuiCardHeader-title': { fontFamily: 'Mark-Medium !important', fontSize: '1.125rem' },
};

// ==============================|| CUSTOM MAIN CARD ||============================== //

const MainCard = forwardRef(
  (
    {
      border = true,
      boxShadow,
      children,
      content = true,
      contentClass = '',
      contentSX = {},
      darkTitle,
      secondary,
      shadow,
      sx = {},
      title,
      ...others
    },
    ref
  ) => {
    const theme = useTheme();

    return (
      <Card
        ref={ref}
        {...others}
        sx={{
          border: '1px solid !important',
          borderColor: '#d7e9f6 !important',
          ':hover': {
            boxShadow: '0 2px 14px 0 rgb(32 40 45 / 8%) !important',
          },
          ...sx,
          borderRadius: '12px !important',
          boxShadow: 'none',
          border: '1px solid !important',
          borderColor: '#d7e9f6 !important',
          ':hover': {
            boxShadow: '0 2px 14px 0 rgb(32 40 45 / 8%) !important',
          },
          //   ...sx,
        }}
      >
        {/* card header and action */}
        {!darkTitle && title && <CardHeader sx={headerSX} title={title} action={secondary} />}
        {darkTitle && title && (
          <CardHeader sx={headerSX} title={<Typography variant="h3">{title}</Typography>} action={secondary} />
        )}

        {/* content & header divider */}
        {title && (
          <Divider
            sx={{
              ...sx,
              opacity: 1,
              borderColor: '#e3f2fd !important',
              borderStyle: 'solid !important',
            }}
          />
        )}

        {/* card content */}
        {content && (
          <CardContent sx={contentSX} className={contentClass}>
            {children}
          </CardContent>
        )}
        {!content && children}
      </Card>
    );
  }
);

MainCard.propTypes = {
  border: PropTypes.bool,
  boxShadow: PropTypes.bool,
  children: PropTypes.node,
  content: PropTypes.bool,
  contentClass: PropTypes.string,
  contentSX: PropTypes.object,
  darkTitle: PropTypes.bool,
  secondary: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
  shadow: PropTypes.string,
  sx: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
};

export default MainCard;
